module.exports = __webpack_public_path__ + "4f9177a13f6ea668bd69030123d36319.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/camp5.jpeg
// module id = 1139
// module chunks = 0